import React from "react";
import { Modal } from "react-bootstrap";

const DeleteModal = React.memo(function DeleteModal({
  show,
  onClose,
  onDelete,
  message = "Are you sure you want to delete this?",
}) {
  return (
    <Modal
      className="delete-news-modal"
      show={show}
      onHide={onClose}
      dialogClassName="modal-90w"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="delete-title">Delete Confirmation</Modal.Title>
      </Modal.Header>

      <div className="lineSeperate"></div>

      <Modal.Body className="delete-body ps-4">
        <p>{message}</p>
      </Modal.Body>

      <div className="lineSeperate"></div>

      <div className="d-flex justify-content-end align-items-center mainBtnsSub">
        <button className="btn-width cancelBtn mx-3" onClick={onClose}>
          Cancel
        </button>

        <button
          className="btn-width saveBtn"
          onClick={() => {
            onDelete();
            onClose();
          }}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
});

export default DeleteModal;
